import { render } from "./view-notification.vue?vue&type=template&id=39fcd39c"
import script from "./view-notification.vue?vue&type=script&lang=js"
export * from "./view-notification.vue?vue&type=script&lang=js"

import "./view-notification.vue?vue&type=style&index=0&id=39fcd39c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__